export const SetRelativePosition = {
  mounted() {
    set_position(this);
  },

  updated() {
    set_position(this);
  },
};

function set_position(hook) {
  const element = hook?.el;
  if (!element) return;

  const containerId = element.dataset.containerId;
  const anchorSelector = element.dataset.anchorSelector;
  const anchorId = element.dataset.childId;

  const container = containerId ? document.getElementById(containerId) : null;
  const anchor = anchorSelector
    ? document.querySelector(anchorSelector)
    : anchorId
      ? document.getElementById(anchorId)
      : null;

  if (!container) return;

  // Sometimes the anchor isn't in the DOM yet. Retry once after a short delay.
  if (!anchor) {
    if (hook._setRelativePositionRetryTimeout) return;

    hook._setRelativePositionRetryTimeout = window.setTimeout(() => {
      hook._setRelativePositionRetryTimeout = null;
      set_position(hook);
    }, 500);

    return;
  }

  // Configuration
  const gap = Number.parseFloat(element.dataset.gap ?? "") || 5;
  const preferred = (element.dataset.position ?? "").toLowerCase();
  const mode = preferred === "vertical" ? "vertical" : "horizontal";

  // Geometry (all in viewport coordinates, then converted to container-relative)
  const containerRect = container.getBoundingClientRect();
  const anchorRect = anchor.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  const containerWidth = containerRect.width;
  const containerHeight = containerRect.height;

  const anchorTop = anchorRect.top - containerRect.top;
  const anchorBottom = anchorRect.bottom - containerRect.top;
  const anchorLeft = anchorRect.left - containerRect.left;
  const anchorRight = anchorRect.right - containerRect.left;

  const elementWidth = elementRect.width;
  const elementHeight = elementRect.height;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  // Reset the properties we may set so switches between modes don't accumulate.
  element.style.left = "";
  element.style.right = "";
  element.style.top = "";

  if (mode === "vertical") {
    // Try below, otherwise above (based on available container space)
    const spaceBelow = containerHeight - anchorBottom;
    const spaceAbove = anchorTop;
    const placeBelow =
      spaceBelow >= elementHeight + gap || spaceBelow >= spaceAbove;

    const desiredTop = placeBelow
      ? anchorBottom + gap
      : anchorTop - elementHeight - gap;
    const top = clamp(
      desiredTop,
      gap,
      Math.max(gap, containerHeight - elementHeight - gap),
    );

    // Align left edge with anchor, clamp within container
    const desiredLeft = anchorLeft;
    const left = clamp(
      desiredLeft,
      gap,
      Math.max(gap, containerWidth - elementWidth - gap),
    );

    element.style.left = `${left}px`;
    element.style.top = `${top}px`;
    return;
  }

  // Horizontal (default): try to the right, otherwise to the left.
  const spaceRight = containerWidth - anchorRight;
  const spaceLeft = anchorLeft;
  const placeRight =
    spaceRight >= elementWidth + gap || spaceRight >= spaceLeft;

  const desiredLeft = placeRight
    ? anchorRight + gap
    : anchorLeft - elementWidth - gap;
  const left = clamp(
    desiredLeft,
    gap,
    Math.max(gap, containerWidth - elementWidth - gap),
  );

  // Align top edge with anchor, clamp within container height
  const desiredTop = anchorTop;
  const top = clamp(
    desiredTop,
    gap,
    Math.max(gap, containerHeight - elementHeight - gap),
  );

  element.style.left = `${left}px`;
  element.style.top = `${top}px`;
}
